import { createSlice } from "@reduxjs/toolkit";
import { complete as measurementComplete } from '../measurement/measurementSlice';

export interface CancellationState {
    cancellationDialogVisible: boolean;
}

const initialState: CancellationState = {
    cancellationDialogVisible: false
}

export const cancellationSlice = createSlice({
    name: 'cancellation',
    initialState,
    reducers: {
        showCancellationDialog: (state) => {
            state.cancellationDialogVisible = true;
        },
        hideCancellationDialog: (state) => {
            state.cancellationDialogVisible = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(measurementComplete, (state) => {
            state.cancellationDialogVisible = false;
        });
    }    
});

export const { showCancellationDialog, hideCancellationDialog } = cancellationSlice.actions;

export default cancellationSlice;